import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ShareButton from '../ShareButton';
import FeedbackButtons from '../FeedbackButtons';
import BookmarkButton from '../BookmarkButton';
import { CookieStateContext } from '../../containers/BasePage/state';

import styles from './ShareFeedbackSegment.module.scss';

const ShareFeedbackSegment = ({ articleId, bookmark, modifier }) => {
    const { state } = useContext(CookieStateContext) || {};
    const cookieConsent = state?.categories?.includes('functionality');

    const classes = classNames(styles['ShareFeedbackSegment'], {
        [styles[`ShareFeedbackSegment--${modifier}`]]: modifier,
    });

    return (
        <div className={classes}>
            <div
                className={
                    styles['ShareFeedbackSegment__Container'] +
                    ' ' +
                    styles['ShareFeedbackSegment__Container--Share']
                }>
                {cookieConsent && (
                    <BookmarkButton
                        {...bookmark}
                        untranslatedModifiers={[
                            'BookmarkButton--InsideShareFeedbackSegment',
                        ]}
                        untranslatedButtonModifiers={[
                            'Button--InsideShareFeedbackSegment',
                        ]}
                        isNextToShare={true}
                    />
                )}
                <div className={styles['ShareFeedbackSegment__ShareWrapper']}>
                    <ShareButton
                        untranslatedButtonModifiers={[
                            'Button--InsideShareFeedbackSegment',
                        ]}
                    />
                </div>
            </div>
            <div
                className={
                    styles['ShareFeedbackSegment__Container'] +
                    ' ' +
                    styles['ShareFeedbackSegment__Container--Feedback']
                }>
                <FeedbackButtons articleId={articleId} />
            </div>
        </div>
    );
};

ShareFeedbackSegment.propTypes = {
    articleId: PropTypes.number,
    bookmark: PropTypes.object,
};

export default ShareFeedbackSegment;
